import * as React from 'react'
import { ResortImprovement } from '@models/reservation'
import { ImprovementCard } from '@modules/improvement-step/improvements-sections/kinds/improvements/improvement-card'

interface Props {
  resortImprovements: ResortImprovement[]
}

export const Improvements = ({ resortImprovements }: Props): JSX.Element => (
  <div className="d-flex flex-column flex-sm-row gap-4 gap-sm-0 gy-4 row">
    {resortImprovements.map((improvement: ResortImprovement) => (
      <ImprovementCard key={improvement.id} improvement={improvement} />
    ))}
  </div>
)
